// extracted by mini-css-extract-plugin
export var addToCartButton = "_og-b";
export var arrowButtonContainer = "_og-9";
export var arrowButtonIcon = "_og-a";
export var carouselArrowButton = "_og-6";
export var carouselElementContainer = "_og-1";
export var galleryThumbnail = "_og-d";
export var galleryThumbnailImage = "_og-e";
export var left = "_og-7";
export var productDisplayCarouselContainer = "_og-0";
export var productTileContainer = "_og-2";
export var productTileImage = "_og-4";
export var productTileImageContainer = "_og-3";
export var productTileTitle = "_og-5";
export var right = "_og-8";
export var sliderOverflow = "_og-c";